<template>
  <TemplatesManagerModalWrapper :show="value">
    <TemplatesManager
      class="shadow-xl rounded-lg sm:max-w-7xl sm:w-full bg-white"

      message="Please be sure to save your current config changes before importing a template."
      inner-max-width="sm:max-w-4xl"
      :value="value"

      @input="val => $emit('input', val)"
      @edit-template="obj => $emit('edit-template', obj)"
      @trigger-default-template="$emit('trigger-default-template')"
      @close-manager="$emit('close-manager')"

      ref="manager"
    />
  </TemplatesManagerModalWrapper>
</template>

<script>

import TemplatesManagerModalWrapper from "@/components/SideEditor/TemplatesManager/TemplatesManagerModalWrapper"
import TemplatesManager from "@/components/SideEditor/TemplatesManager/TemplatesManager"

export default {
  components: {
    TemplatesManager,
    TemplatesManagerModalWrapper,
  },
  props: ['value'],
  methods: {
    reload() {
      this.$refs.manager.reload()
    },
  },
}

</script>
